export default "__VITE_ASSET__7cOwoZs2__"